export enum DrawingButtonsIcon {
  marker = 'flag',
  area = 'rounded_corner',
  circle = 'panorama_fish_eye',
  close = 'close',
}
